@import "../../../conversational-search-partials/label-with-section/label-with-section.scss";
@import "../../../conversational-search-partials/feedback/feedback.scss";
@import "../../../../../../styles/variables";

.conversational-search-banner-dynamic-data-result {
  animation: fade-in-left-to-right 0.5s ease-out;
  flex: 1;
  max-width: 100%;

  &-footer {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;

    qds-inline-link {
      cursor: pointer;
    }

    &-fallback {
      align-content: center;
      animation: fade-in-opacity 0.4s ease-in-out;
      display: flex;

      &__intro {
        margin-left: 4px;
        margin-right: 4px;
      }
    }

    .conversational-search-feedback {
      animation: fade-in-opacity 0.4s ease-in-out;
      float: left;
      @media (max-width: 780px) {
        width: calc(100% - 44px);
      }
    }
  }
}

@keyframes fade-in-left-to-right {
  0% {
    opacity: 0;
    clip-path: inset(0 100% 0 0);
  }

  100% {
    opacity: 1;
    clip-path: inset(0 0 0 0);
  }
}

@keyframes fade-in-opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.tooltip-links {
  color: #0075a3;
  text-decoration: underline;
}

.outro-tooltip {
  float: left;
}
